import { Injectable } from '@angular/core';
import type { Observable } from 'rxjs';

import { BaseHttpService } from '@common/services/REST/base.http.service';

@Injectable({
    providedIn: 'root',
})
export class CommonHttpService extends BaseHttpService {
    public getVimeoPreview(params: string): Observable<any> {
        return this.http.get(`https://vimeo.com/api/oembed.json${params}`);
    }
}
